<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="medium"
             color="#000000"
             type="ball-spin-clockwise">
</ngx-spinner>

<div [class.isPrinting]="printService.isPrinting">

  <div class="job-posts placements agreements margin-top-service-30px top-link">
    <div class="card my-profile-form skillassest-form">



    </div>
    <div class="card-body padding-top padding-left-0px padding-right-0px">
      <div class="row">
        <div class="col-md-3 padding-right-0px colmd3 ">
          <div class="position-fixed-scans border-right2 padding-right-5px height-100pe">
            <div class="card height-100pe">

              <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
                <div class="row margin-top10px margin-left-20px  nav-link-hand">
                  <div class="col-md-10 padding-left-0px">
                    <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                      Follicular Pickup
                    </label>
                  </div>


                  <!--<div class=" col-md-2 padding-left-0px col-sm-4 text-align-right padding-right-10px">

                    <label for="diaplayName " class="font-size-15px margin-top-5px margin-bottom-0px">Date</label>
                  </div>-->


                  <div class="col-md-1">
                    <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
                  </div>
                  <!--<a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Services"
                  *ngIf="ShowIcon"><i class="fas fa-angle-double-left font-size-19px"></i></a>-->

                </div>




              </div>
              <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
                <div class="row border-top margin-left-0px margin-right-0px">
                  <div class="col-md-5 col-sm-4 padding-right-0px my-profile-form margin-left-10px">
                    <div class="date-form margin-top-5px form-group margin-bottom-0px">
                      <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                             name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                      <a (click)="d.toggle()" class="nav-link-hand">
                        <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                      </a>

                    </div>



                  </div>
                  <div class="col-md-1 " (click)="DecrementDate()">
                    <a title="Previous" class="nav-link-hand">
                      <i class="fas fa-caret-left margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                  <div class="col-md-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                    <a title="Next" class="nav-link-hand">
                      <i class="fas fa-caret-right margin-top-10 font-size-20px color-secondary-hover"></i>
                    </a>
                  </div>
                </div>
                <div class="row   margin-right-0px margin-left-0px">
                  <div class="col-md-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                    <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                    <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
                  </div>
                  <div class="col-md-2" hidden>
                    <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Edit">
                      <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                    </a>

                  </div>
                  <div class="col-md-1 padding-left-8px" hidden>
                    <a class="nav-link-hand education-navlink" tooltip="Delete">
                      <span class="badge font-size-14">
                        <i class="far fa-trash-alt"></i>
                      </span>
                    </a>
                  </div>

                </div>
                <div>
                  <div class="chatsd product-chart-wrapper product-chat-width-97 agreement-chart-wrapper ps scroll padding-lrt " data-ps-id="dfsfsde">
                    <div *ngIf="isRequesting">
                      <div class="loader-text">
                        <div class="loader-text2">

                          <div class="lds-facebook">
                            <div></div>
                            <div></div>
                            <div></div>
                          </div>
                          <div class="margin-top-20px margin-left-5px">
                            <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                          </div>
                          <!--Loading Please Wait...-->
                        </div>
                      </div>
                      <!--<div class="loadernew"></div>-->


                    </div>
                    <div *ngIf="!isRequesting">

                      <div class="row border-bottom row-for-scans2 margin-left16px nav-link-hand" (click)="Selectedpatient(l)" *ngFor="let l of pdata">
                        <div class="col-md-2 padding-left-0px margin-top-5px" (click)="Selectedpatient(l)">
                          <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.OwnerPatientImageFile" onError="this.src='dummy.jpg';">



                        </div>
                        <div class="col-md-7 margin-top-5px padding-right-0px padding-left-10px">
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="margin-bottom-0px td-elipsis-scan font-size-14">{{l.OwnerName}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-12">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerAgeYears}}Years,{{l.OwnerFormattedCode}}</label>
                            </div>
                          </div>
                          <div class="row row-height-17px">
                            <div class="col-md-4">
                              <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerTelephone1}}</label>
                            </div>
                          </div>

                        </div>
                        <div class="col-md-3 padding-left-0px margin-top-5px">
                          <div class="text-align-center"><label class="font-size-12px">#{{l.CycleNo}}</label></div>
                          <div class="text-align-center">
                            <a data-toggle="tooltip" data-placement="bottom" title="Completed" *ngIf="l.ActivityStatus=='Completed'">

                              <i class="fas fa-check-circle color-icon-completed font-size-16px">
                              </i>
                            </a>
                            <a data-toggle="tooltip" data-placement="bottom" title="Initiated" *ngIf="l.ActivityStatus=='Initiated'">

                              <i class="fas fa-check-circle color-gray font-size-16px">
                              </i>
                            </a>
                          </div>

                          <!--<div class="text-align-center"><label class="font-size-12px">{{l.LastUpdatedTime | date: 'hh:mm a'}}</label></div>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

              </div>

            </div>
          </div>
        </div>

        <div class="col-md-6 padding-left-17px padding-right-8px" *ngIf="ScanDetails">

          <div class="row" *ngIf="SelectedpatientDetails">
            <div class="col-md-12 padding-left-0px">
              <div class="card">
                <div class="card-header wh-header border-bottom padding-left-5px padding-right-0px">
                  <div class="row">
                    <div class="col-md-1 ">
                      <img class=" margin-left-6px image-width-scans" [src]="SelectedpatientDetails.EggPatientImageFile" onError="this.src='dummy.jpg';">
                    </div>
                    <div class="col-md-4 margin-left-18">
                      <div class="row row-height-17px margin-left-0px">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal color-secondary">{{SelectedpatientDetails.EggName}} </label>
                        </div>

                      </div>
                      <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>
                      <!--<div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType==''">
                        <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                          <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                        </div>
                      </div>-->

                      <div class="row row-height-17px">
                        <div class="col-md-12">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggAgeYears}} years,{{SelectedpatientDetails.EggFormattedCode}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-4">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggTelephone1}}</label>
                        </div>
                      </div>
                      <div class="row row-height-17px">
                        <div class="col-md-3">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Cycle#{{SelectedpatientDetails.CycleNo}},</label>
                        </div>
                        <div class="col-md-9 padding-left-6px">
                          <label class="font-size-12px margin-bottom-0px font-weight-normal">Start Date: {{SelectedpatientDetails.ProtocolStartDate | date:'MMM-dd-yyyy'}}</label>
                        </div>

                      </div>
                    </div>
                    <div class="col-md-6  padding-right-0px">
                      <!--<div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="PickupData2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{PickupData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
                        </div>
                      </div>-->
                      <div class="row font-size-12px">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px" *ngIf="PickupData2">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{PickupData2.ActivityStatus}}</label>
                        </div>
                      </div>
                      <div class="row font-size-12px" *ngIf="FollicularPickupEndInfo">
                        <div class="col-md-6 margin-left-auto text-align-right padding-right-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">Pickup Date </label>
                        </div>:
                        <div class="col-md-3 padding-right-0px padding-left-10px">
                          <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularPickupEndInfo.OvumPickupdate | date:'MMM-dd-yyyy'}}</label>
                        </div>
                      </div>
                      <div class="row margin-right-0px">
                        <div class="Dsa1 margin-left-auto" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.DOC}}</label>
                        </div>
                        <div class="Dsa2" *ngIf="DSADetails">
                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.STIMULATION}}</label>
                        </div>
                        <div class="Dsa3" *ngIf="DSADetails">

                          <label class="margin-bottom-0px font-weight-normal padding-top-6px padding-bottom-6px padding-right-6px font-size-14">{{DSADetails.ANTAG}}</label>
                        </div>

                      </div>
                    </div>
                  </div>

                </div>
                <div class="card-body padding-right-0px padding-top-0px">
                  <div class="card">
                    <div class="card-header wh-header border-bottom-1px padding-top-6px padding-bottom-6px padding-left-0px padding-right-0px">
                      <div class="row nav-link-hand margin-right-0px" id="edit-link">
                        <div class="col-md-5 padding-right-0px">
                          <label class="margin-bottom-0px font-size-16px font-weight-normal">
                            Follicular Pickup
                          </label>
                        </div>
                        <div class="col-md-6  padding-right-0px display-edit">
                          <!--<a class="nav-link-hand education-navlink " title="To View images"><i class="far fa-image"></i></a>-->
                          <div class="row">
                            <div class="col-md-11 margin-top-3px padding-left-0px" *ngIf="FollicularPickupEndInfo && PickupData2 ">
                              <a class="nav-link-hand float-right patientreg-link padding-top-2px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp || PickupData2.ActivityStatus !=='Completed'">Is Pickup Confirmed</a>
                            </div>

                          </div>
                        </div>
                        <div class="col-md-1 padding-left-0px" *ngIf="PickupData2">
                          <a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printpickup()">
                            <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                          </a>
                          <!--<a class="nav-link-hand education-navlink data-color-new" title="print" (click)="printpickup()" *ngIf="PickupData2.ActivityStatus =='Completed'">
                            <span class="badge font-size-16px padding-left-0px padding-top-0px padding-bottom-0px"><i class="fa fa-print"></i></span>
                          </a>-->
                        </div>

                      </div>
                    </div>
                    <div class=" padding-lrt " data-ps-id="dfsfsde">
                      <div class="card-body">
                        <div *ngIf="FollicularPickupEndInfo">
                          <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                          Ovulation Trigger
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button (click)="SaveOvulationtrigger()" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp" hidden>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                  </div>


                                </div>

                                <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <!--<div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row">
                                          <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Trigger Type </label>
                                          </div>


                                          <div class="col-md-4">

                                            <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.triggertype}}</label>

                                          </div>

                                        </div>


                                      </div>
                                    </div>-->
                                    <div class="row my-profile-form">
                                      <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                        <div class="row font-size-12px">
                                          <div class="col-md-3  text-align-right margin-tg-auto ">
                                            <label for="diaplayName" class=" margin-bottom-0px">Trigger Type </label>
                                          </div>:


                                          <div class="col-md-4 margin-tg-auto">
                                            <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.triggertype}}</label>
                                            <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                     id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                     [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                     name="FollicularPickupEndInfo.MedicineCode" required>
                                            </CustomDataByRequestType>-->
                                            <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                            <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                            name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                            maxlength="100" required>-->
                                            <!--<small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                            <small class="form-text text-danger"
                                                   *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                          </div>

                                        </div>


                                      </div>
                                    </div>
                                    <div class="accordion margin-bottom-20px margin-top-3px" id="accordionExampleDOse1">
                                      <div class="card margin-bottom-5px">
                                        <div class="card-header font-weight-normal wh-header border-all-0px  label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingDose1">
                                          <div class="row">
                                            <div class="col-md-4 text-align-center padding-right-0px">
                                              <h5 class="mb-0 height-24px">
                                                <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px border-left-female" type="button" data-toggle="collapse" data-target="#collapseDoseOne" aria-expanded="true" aria-controls="collapseDoseOne">
                                                  <h4 class="margin-bottom-0px margin-left-8px font-size-16px">Dose1</h4>
                                                </button>
                                              </h5>
                                            </div>

                                          </div>


                                        </div>

                                        <div id="collapseDoseOne" class="collapse show" aria-labelledby="headingDOseOne" data-parent="#accordionExampleDOse1">
                                          <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                            <div class="card">

                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class=" margin-bottom-0px">Trigger Date </label>
                                                    </div>:


                                                    <div class="col-md-5 margin-tg-auto">

                                                      <!--<div class="date-form">
                                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                               name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                                        <small class="form-text text-danger"
                                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                        </a>

                                                      </div>-->
                                                      <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.OvulationTriggerDate | date:'MMM-dd-yyyy'}}</label>
                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class=" margin-bottom-0px">Trigger Time </label>
                                                    </div>:


                                                    <div class="col-md-3 margin-tg-auto">


                                                      <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.TriggerTime" placeholder="Schedule Time"
                                                      [(ngModel)]="FollicularPickupEndInfo.TriggerTime"
                                                      name="FollicularPickupEndInfo.TriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                                      <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.OvulationTriggerTime" placeholder="Trigger Time"
                                                      [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"
                                                      name="FollicularPickupEndInfo.OvulationTriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                                      <!--<input class="form-control" [ngxTimepicker]="picker" [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime" name="FollicularPickupEndInfo.OvulationTriggerTime">
                                                      <ngx-material-timepicker #picker></ngx-material-timepicker>-->
                                                      <!--<ngb-timepicker [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"></ngb-timepicker>-->
                                                      <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.OvulationTriggerTime| slice:11}}</label>
                                                      <!--<label class="margin-bottom-0px " *ngIf="OvulationDateTime">{{OvulationDateTime|date: 'hh:mm a'}}</label>-->
                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class=" margin-bottom-0px">Medicine </label>
                                                    </div>:


                                                    <div class="col-md-4 margin-tg-auto">
                                                      <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.MedicineName}}</label>
                                                      <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                               id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                               [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                               name="FollicularPickupEndInfo.MedicineCode" required>
                                                      </CustomDataByRequestType>-->
                                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                                      maxlength="100" required>-->
                                                      <!--<small class="form-text text-danger"
                                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                                      <small class="form-text text-danger"
                                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class="margin-bottom-0px">Dose </label>
                                                    </div>:


                                                    <div class="col-md-3 margin-tg-auto">

                                                      <!--<input type="text" class="form-control" placeholder="Dose" id="FollicularPickupEndInfo.Dosage"
                                                      [(ngModel)]="FollicularPickupEndInfo.Dosage" required
                                                      name="FollicularPickupEndInfo.Dosage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                                      maxlength="100">-->

                                                      <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.Dosage}}</label>
                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class="margin-bottom-0px">Batch </label>
                                                    </div>:


                                                    <div class="col-md-3 margin-tg-auto">
                                                      <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.BatchNo}}</label>


                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class=" margin-bottom-0px">Expiry Date </label>
                                                    </div>:


                                                    <div class="col-md-5 margin-tg-auto">

                                                      <!--<div class="date-form">
                                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                               name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                                        <small class="form-text text-danger"
                                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                        </a>

                                                      </div>-->
                                                      <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.ExpiryDate| date:'MMM-dd-yyyy'}}</label>
                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="accordion" id="accordionExampleDOse2" *ngIf="FollicularPickupEndInfo.triggertype=='Dual Trigger' || FollicularPickupEndInfo.triggertype=='Double Trigger' ">
                                      <div class="card margin-bottom-5px">
                                        <div class="card-header font-weight-normal wh-header border-all-0px  label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingDose2">
                                          <div class="row">
                                            <div class="col-md-4 text-align-center padding-right-0px">
                                              <h5 class="mb-0 height-24px">
                                                <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px border-left-female" type="button" data-toggle="collapse" data-target="#collapseDoseTwo" aria-expanded="true" aria-controls="collapseDoseTwo">
                                                  <h4 class="margin-bottom-0px margin-left-8px font-size-16px">Dose2</h4>
                                                </button>
                                              </h5>
                                            </div>

                                          </div>


                                        </div>

                                        <div id="collapseDoseTwo" class="collapse show" aria-labelledby="headingDOseTwo" data-parent="#accordionExampleDOse2">
                                          <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">

                                            <div class="card">

                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class=" margin-bottom-0px">Trigger Date </label>
                                                    </div>:


                                                    <div class="col-md-5 margin-tg-auto">

                                                      <!--<div class="date-form">
                                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                               name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                                        <small class="form-text text-danger"
                                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                        </a>

                                                      </div>-->
                                                      <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.OvulationTriggerDate2| date:'MMM-dd-yyyy'}}</label>
                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class=" margin-bottom-0px">Trigger Time </label>
                                                    </div>:


                                                    <div class="col-md-3 margin-tg-auto">


                                                      <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.TriggerTime" placeholder="Schedule Time"
                                                      [(ngModel)]="FollicularPickupEndInfo.TriggerTime"
                                                      name="FollicularPickupEndInfo.TriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                                      <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.OvulationTriggerTime" placeholder="Trigger Time"
                                                      [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"
                                                      name="FollicularPickupEndInfo.OvulationTriggerTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->
                                                      <!--<input class="form-control" [ngxTimepicker]="picker" [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime" name="FollicularPickupEndInfo.OvulationTriggerTime">
                                                      <ngx-material-timepicker #picker></ngx-material-timepicker>-->
                                                      <!--<ngb-timepicker [(ngModel)]="FollicularPickupEndInfo.OvulationTriggerTime"></ngb-timepicker>-->
                                                      <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.OvulationTriggerTime2| slice:11}}</label>
                                                      <!--<label class="margin-bottom-0px " *ngIf="OvulationDateTime">{{OvulationDateTime|date: 'hh:mm a'}}</label>-->
                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class=" margin-bottom-0px">Medicine </label>
                                                    </div>:


                                                    <div class="col-md-4 margin-tg-auto">
                                                      <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.MedicineName2}}</label>
                                                      <!--<CustomDataByRequestType RequestedType="IvfFolScanDayMeds" ActorCode={{ActorCode}}
                                                                               id="FollicularPickupEndInfo.MedicineCode" SelectedValue=""
                                                                               [(ngModel)]="FollicularPickupEndInfo.MedicineCode" (keyChange)="onAssignedToActorCode2($event)"
                                                                               name="FollicularPickupEndInfo.MedicineCode" required>
                                                      </CustomDataByRequestType>-->
                                                      <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                                      maxlength="100" required>-->
                                                      <!--<small class="form-text text-danger"
                                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                                      <small class="form-text text-danger"
                                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class="margin-bottom-0px">Dose </label>
                                                    </div>:


                                                    <div class="col-md-3 margin-tg-auto">

                                                      <!--<input type="text" class="form-control" placeholder="Dose" id="FollicularPickupEndInfo.Dosage"
                                                      [(ngModel)]="FollicularPickupEndInfo.Dosage" required
                                                      name="FollicularPickupEndInfo.Dosage" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                                      maxlength="100">-->

                                                      <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.Dosage2}}</label>
                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class="margin-bottom-0px">Batch </label>
                                                    </div>:


                                                    <div class="col-md-3 margin-tg-auto">
                                                      <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.BatchNo2}}</label>

                                                      <!--<input type="text" class="form-control" [disabled]="true" id="CurrentSaveFollicularPickupsDetailV2Request.Batch" placeholder="Batch"
                                                      [(ngModel)]="CurrentSaveFollicularPickupsDetailV2Request.Batch"
                                                      name="CurrentSaveFollicularPickupsDetailV2Request.Batch" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />-->

                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                              <div class="row my-profile-form">
                                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                  <div class="row font-size-12px">
                                                    <div class="col-md-3  text-align-right margin-tg-auto ">
                                                      <label for="diaplayName" class=" margin-bottom-0px">Expiry Date </label>
                                                    </div>:


                                                    <div class="col-md-5 margin-tg-auto">

                                                      <!--<div class="date-form">
                                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                               name="dp1" [(ngModel)]="OvulationTriggerDate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                                        <small class="form-text text-danger"
                                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                        </a>

                                                      </div>-->
                                                      <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.ExpiryDate2 | date:'MMM-dd-yyyy'}}</label>
                                                    </div>

                                                  </div>


                                                </div>
                                              </div>
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>


                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitSchedule()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample2" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                          Schedule
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp" [disabled]="DateOfBirth.errors?.required || ActivityTime.errors?.required">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                    <!--<div class="col-md-6">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                    </div>-->
                                  </div>


                                </div>

                                <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="font-weight-normal font-size-14">Add/Edit</label>
                                          </div>
                                          <div class="col-md-3 text-align-right">
                                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                          </div>
                                        </div>

                                      </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px">

                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Planned Date </label>
                                              </div>


                                              <div class="col-md-3 padding-right-0px">

                                                <div class="date-form">
                                                  <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                         name="dp2" [(ngModel)]="OvumPlannedPickupDate" ngbDatepicker #d2="ngbDatepicker" #DateOfBirth2="ngModel" required>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!DateOfBirth2.valid && (DateOfBirth2.dirty || DateOfBirth2.touched) && DateOfBirth2.errors.required)">(Field cannot be left blank)</small>
                                                  <a (click)="d2.toggle()" class="nav-link-hand">
                                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                  </a>

                                                </div>

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Planned Time </label>
                                              </div>


                                              <div class="col-md-3 padding-right-0px">

                                                <input type="text" class="form-control" id="FollicularPickupEndInfo.PlannedTime"
                                                       [(ngModel)]="FollicularPickupEndInfo.PlannedTime"
                                                       name="FollicularPickupEndInfo.PlannedTime"
                                                       maxlength="20" minlength="1" #PlannedTime="ngModel" pattern="^[\sa-zA-Z0-9,:._\-?]*$">
                                                <small class="form-text text-danger"
                                                       *ngIf="(!PlannedTime.valid && (PlannedTime.dirty || PlannedTime.touched) && PlannedTime.errors.required)">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!PlannedTime.valid && PlannedTime.errors.pattern)">(special characters are not allowed)</small>

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <!--<div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">

                                            <div class="row font-size-12px">
                                              <div class="col-md-3  text-align-right padding-right-5px">
                                                <label class="font-weight-normal font-size-12px margin-bottom-0px">Planned Time </label>
                                              </div>:
                                              <div class="col-md-3 padding-right-0px  padding-left-9px">
                                                <label class="font-weight-normal font-size-12px margin-bottom-0px">{{FollicularPickupEndInfo.OvumPlannedPickupTime}}</label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>-->
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Actual Date </label>
                                              </div>


                                              <div class="col-md-3 padding-right-0px">

                                                <div class="date-form">
                                                  <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                         name="dp1" [(ngModel)]="OvumPickupdate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                                  <a (click)="d1.toggle()" class="nav-link-hand">
                                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                  </a>

                                                </div>

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Actual Time </label>
                                              </div>


                                              <div class="col-md-3 padding-right-0px">

                                                <input type="time" class="form-control" id="FollicularPickupEndInfo.OvumPickupTime" placeholder="Trigger Time"
                                                       [(ngModel)]="FollicularPickupEndInfo.OvumPickupTime"
                                                       name="FollicularPickupEndInfo.OvumPickupTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" required />

                                              </div>

                                            </div>


                                          </div>
                                        </div>




                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>


                        <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitSchedule()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample2" *ngIf="PickupData2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                          Schedule
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp" [disabled]="DateOfBirth.errors?.required || ActivityTime.errors?.required">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                    <!--<div class="col-md-6">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                    </div>-->
                                  </div>


                                </div>

                                <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px">


                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row my-profile-form">
                                              <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                                <div class="row">
                                                  <div class="col-md-3 text-align-right margin-tg-auto ">
                                                    <label for="diaplayName" class="margin-bottom-0px">Planned Date </label>
                                                  </div>:


                                                  <div class="col-md-3 margin-tg-auto ">

                                                    <label class="margin-bottom-0px">{{FollicularPickupEndInfo.OvumPlannedPickupDate | date:'MMM-dd-yyyy'}}</label>
                                                  </div>

                                                </div>


                                              </div>
                                            </div>
                                            <div class="row font-size-12px">
                                              <div class="col-md-3  text-align-right margin-tg-auto ">
                                                <label class="margin-bottom-0px">Planned Time </label>
                                              </div>:
                                              <div class="col-md-3 margin-tg-auto ">
                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.OvumPlannedPickupTime| slice:11}}</label>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Actual Date </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto ">

                                                <!--<div class="date-form">
                                                  <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                                         name="dp1" [(ngModel)]="OvumPickupdate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel" required>
                                                  <small class="form-text text-danger"
                                                         *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                                  <a (click)="d1.toggle()" class="nav-link-hand">
                                                    <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                                  </a>

                                                </div>-->

                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.OvumPickupdate | date:'MMM-dd-yyyy'}}</label>
                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Actual Time </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">

                                                <!--<input type="time" class="form-control" id="FollicularPickupEndInfo.OvumPickupTime" placeholder="Trigger Time"
                                                [(ngModel)]="FollicularPickupEndInfo.OvumPickupTime"
                                                name="FollicularPickupEndInfo.OvumPickupTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" required />-->

                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.OvumPickupTime| slice:11}}</label>

                                              </div>

                                            </div>


                                          </div>
                                        </div>




                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitTeam()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample3" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingThree">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                          Team
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp" [disabled]="Surgeon.errors?.required || AsstSurgeon.errors?.required || Anaesthetist.errors?.required">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                    <!--<div class="col-md-6">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                    </div>-->
                                  </div>


                                </div>

                                <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample3">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px">


                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Surgeon </label>
                                              </div>


                                              <div class="col-md-3">
                                                <CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                                         id="FollicularPickupEndInfo.Surgeon" SelectedValue="FollicularPickupEndInfo.Surgeon"
                                                                         [(ngModel)]="FollicularPickupEndInfo.Surgeon" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                                         name="FollicularPickupEndInfo.Surgeon" required #Surgeon="ngModel">
                                                </CustomDataByRequestType>
                                                <!--<input type="text" class="form-control" placeholder="Surgeon" id="FollicularPickupEndInfo.SurgeonName"
                                                [(ngModel)]="FollicularPickupEndInfo.SurgeonName" required
                                                name="FollicularPickupEndInfo.SurgeonName" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                                maxlength="100">-->
                                                <!--<CodeTypeValue CodeType="FNSTS"
                                                                      id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                                [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                                name="CurrentEditCounsellingPalnRequest.FinancialStatus">
                                                                     </CodeTypeValue>-->
                                                <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                                maxlength="100" required>-->
                                                <!--<small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>
                                              <!--<div class="col-md-2 padding-left-0px">
                                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectSurgeon()"> <i class="fas fa-ellipsis-h"></i></button>
                                              </div>-->

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Asst.Surgeon </label>
                                              </div>


                                              <div class="col-md-3">
                                                <CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                                         id="FollicularPickupEndInfo.AsstSurgeon" SelectedValue=""
                                                                         [(ngModel)]="FollicularPickupEndInfo.AsstSurgeon" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                                         name="FollicularPickupEndInfo.AsstSurgeon" required #AsstSurgeon="ngModel">
                                                </CustomDataByRequestType>
                                                <!--<input type="text" class="form-control" placeholder="Asst.Surgeon" id="FollicularPickupEndInfoAsstSurgeonName"
                                                [(ngModel)]="FollicularPickupEndInfo.AsstSurgeonName" required
                                                name="FollicularPickupEndInfo.AsstSurgeonName" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                                maxlength="100">-->
                                                <!--<CodeTypeValue CodeType="FNSTS"
                                                                      id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                                [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                                name="CurrentEditCounsellingPalnRequest.FinancialStatus">
                                                                     </CodeTypeValue>-->
                                                <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                                maxlength="100" required>-->
                                                <!--<small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>
                                              <!--<div class="col-md-2 padding-left-0px">
                                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectSurgeon()"> <i class="fas fa-ellipsis-h"></i></button>
                                              </div>-->
                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Anaesthetist </label>
                                              </div>


                                              <div class="col-md-3">
                                                <CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                                                         id="FollicularPickupEndInfo.Anesthesiologist" SelectedValue="FollicularPickupEndInfo.Anesthesiologist"
                                                                         [(ngModel)]="FollicularPickupEndInfo.Anesthesiologist" (keyChange)="onAssignedToActorCodeAnaesthetist($event)"
                                                                         name="FollicularPickupEndInfo.Anesthesiologist" required #Anaesthetist="ngModel">
                                                </CustomDataByRequestType>
                                                <!--<input type="text" class="form-control" placeholder="Anesthesiologist" id="FollicularPickupEndInfo.AnesthesiologistName"
                                                [(ngModel)]="FollicularPickupEndInfo.AnesthesiologistName" required
                                                name="FollicularPickupEndInfo.AnesthesiologistName" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                                maxlength="100">-->
                                                <!--<CodeTypeValue CodeType="FNSTS"
                                                                        id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                                [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                                name="CurrentEditCounsellingPalnRequest.FinancialStatus">
                                                                       </CodeTypeValue>-->
                                                <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                                maxlength="100" required>-->
                                                <!--<small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>
                                              <!--<div class="col-md-2 padding-left-0px">
                                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectSurgeon()"> <i class="fas fa-ellipsis-h"></i></button>
                                              </div>-->
                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Embryologist </label>
                                              </div>


                                              <div class="col-md-3">
                                                <CustomDataByRequestType RequestedType="EMBRYOLOGIST_LIST"
                                                                         id="FollicularPickupEndInfo.Embryologist" SelectedValue="FollicularPickupEndInfo.Embryologist"
                                                                         [(ngModel)]="FollicularPickupEndInfo.Embryologist" (keyChange)="onAssignedToActorCodeEmbryologist($event)"
                                                                         name="FollicularPickupEndInfo.Embryologist" required #Embryologist="ngModel">
                                                </CustomDataByRequestType>
                                                <!--<input type="text" class="form-control" placeholder="Anesthesiologist" id="FollicularPickupEndInfo.AnesthesiologistName"
                                                [(ngModel)]="FollicularPickupEndInfo.AnesthesiologistName" required
                                                name="FollicularPickupEndInfo.AnesthesiologistName" pattern="^[\sa-zA-Z0-9,._\-?]*$" #RecommendedPackage="ngModel"
                                                maxlength="100">-->
                                                <!--<CodeTypeValue CodeType="FNSTS"
                                                                        id="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                                [(ngModel)]="CurrentEditCounsellingPalnRequest.FinancialStatus" SelectedValue="CurrentEditCounsellingPalnRequest.FinancialStatus"
                                                name="CurrentEditCounsellingPalnRequest.FinancialStatus">
                                                                       </CodeTypeValue>-->
                                                <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                                maxlength="100" required>-->
                                                <!--<small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>
                                              <!--<div class="col-md-2 padding-left-0px">
                                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule action-button-prime-cycle actions-btn-prime3   " (click)="SelectSurgeon()"> <i class="fas fa-ellipsis-h"></i></button>
                                              </div>-->
                                            </div>


                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>

                        </div>

                        <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitTeam()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample3" *ngIf="PickupData2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingThree">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
                                          Team
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp" [disabled]="Surgeon.errors?.required || AsstSurgeon.errors?.required || Anaesthetist.errors?.required">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>

                                  </div>


                                </div>

                                <div id="collapseThree" class="collapse show" aria-labelledby="headingThree" data-parent="#accordionExample3">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px">


                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Surgeon </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">
                                                <!--<CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                                         id="FollicularPickupEndInfo.Surgeon" SelectedValue="FollicularPickupEndInfo.Surgeon"
                                                                         [(ngModel)]="FollicularPickupEndInfo.Surgeon" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                                         name="FollicularPickupEndInfo.Surgeon" required #Surgeon="ngModel">
                                                </CustomDataByRequestType>-->

                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.SurgeonName}}</label>
                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Asst.Surgeon </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">
                                                <!--<CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                    id="FollicularPickupEndInfo.AsstSurgeon" SelectedValue=""
                                                    [(ngModel)]="FollicularPickupEndInfo.AsstSurgeon" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                    name="FollicularPickupEndInfo.AsstSurgeon" required #AsstSurgeon="ngModel">
                                                </CustomDataByRequestType>-->

                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.AsstSurgeonName}}</label>
                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Anaesthetist </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">
                                                <!--<CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                                   id="FollicularPickupEndInfo.Anesthesiologist" SelectedValue="FollicularPickupEndInfo.Anesthesiologist"
                                                   [(ngModel)]="FollicularPickupEndInfo.Anesthesiologist" (keyChange)="onAssignedToActorCodeAnaesthetist($event)"
                                                   name="FollicularPickupEndInfo.Anesthesiologist" required #Anaesthetist="ngModel">
                                                </CustomDataByRequestType>-->

                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.AnesthesiologistName}}</label>
                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px">Embryologist </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">
                                                <!--<CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                                   id="FollicularPickupEndInfo.Embryologist" SelectedValue="FollicularPickupEndInfo.Embryologist"
                                                   [(ngModel)]="FollicularPickupEndInfo.Embryologist" (keyChange)="onAssignedToActorCodeEmbryologist($event)"
                                                   name="FollicularPickupEndInfo.Embryologist" required #Embryologist="ngModel">
                                                </CustomDataByRequestType>-->

                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.EmbryologistName}}</label>
                                              </div>

                                            </div>


                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>

                        </div>

                        <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitProcedureDetails()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample4" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFour">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                          Procedure Details
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp" [disabled]="Complication.errors?.required || Route.errors?.required || Batch.errors?.required || Needle.errors?.required || Anaesthesia.errors?.required  ">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                    <!--<div class="col-md-6">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                    </div>-->
                                  </div>


                                </div>

                                <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample4">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="font-weight-normal font-size-14">Add/Edit</label>
                                          </div>
                                          <div class="col-md-3 text-align-right">
                                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                          </div>
                                        </div>

                                      </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px">
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Anaesthesia </label>
                                              </div>


                                              <div class="col-md-3">
                                                <!--<input type="text" class="form-control" placeholder="Needle Used"
                                                id="FollicularPickupEndInfo.NeedleUsed"
                                                [(ngModel)]="FollicularPickupEndInfo.NeedleUsed"
                                                name="FollicularPickupEndInfo.NeedleUsed" #Doctor="ngModel"
                                                maxlength="100" required>-->
                                                <CodeTypeValue CodeType="IVFAT"
                                                               id="FollicularPickupEndInfo.AnaesthesiaType"
                                                               [(ngModel)]="FollicularPickupEndInfo.AnaesthesiaType" SelectedValue="FollicularPickupEndInfo.AnaesthesiaType"
                                                               name="FollicularPickupEndInfo.AnaesthesiaType" required #Anaesthesia="ngModel">
                                                </CodeTypeValue>
                                                <!--<small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>

                                            </div>


                                          </div>
                                        </div>

                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Needle Used </label>
                                              </div>


                                              <div class="col-md-4">
                                                <!--<input type="text" class="form-control" placeholder="Needle Used"
                                                id="FollicularPickupEndInfo.NeedleUsed"
                                                [(ngModel)]="FollicularPickupEndInfo.NeedleUsed"
                                                name="FollicularPickupEndInfo.NeedleUsed" #Doctor="ngModel"
                                                maxlength="100" required>-->
                                                <CodeTypeValue CodeType="IVFPN"
                                                               id="FollicularPickupEndInfo.NeedleUsed"
                                                               [(ngModel)]="FollicularPickupEndInfo.NeedleUsed" SelectedValue="FollicularPickupEndInfo.NeedleUsed"
                                                               name="FollicularPickupEndInfo.NeedleUsed" required #Needle="ngModel">
                                                </CodeTypeValue>
                                                <!--<small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>

                                            </div>


                                          </div>
                                        </div>

                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Batch </label>
                                              </div>


                                              <div class="col-md-3">

                                                <input type="text" class="form-control" placeholder="Batch" id="FollicularPickupEndInfo.NeedleBatchName"
                                                       [(ngModel)]="FollicularPickupEndInfo.NeedleBatchName"
                                                       name="FollicularPickupEndInfo.NeedleBatchName" #Batch="ngModel"
                                                       maxlength="100" required>

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Route </label>
                                              </div>


                                              <div class="col-md-3">
                                                <!--<input type="text" class="form-control" placeholder="Batch" id="FollicularPickupEndInfo.Route"
                                                [(ngModel)]="FollicularPickupEndInfo.Route"
                                                name="FollicularPickupEndInfo.Route" #Route="ngModel"
                                                maxlength="10" required>-->
                                                <CodeTypeValue CodeType="IVFPR"
                                                               id="FollicularPickupEndInfo.Route"
                                                               [(ngModel)]="FollicularPickupEndInfo.Route" SelectedValue="FollicularPickupEndInfo.Route"
                                                               name="FollicularPickupEndInfo.Route" required #Route="ngModel">
                                                </CodeTypeValue>
                                                <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                                maxlength="100" required>-->
                                                <!--<small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Complications </label>
                                              </div>


                                              <div class="col-md-3">
                                                <!--<input type="text" class="form-control" placeholder="Batch" id="FollicularPickupEndInfo.Complications"
                                                [(ngModel)]="FollicularPickupEndInfo.Complications"
                                                name="FollicularPickupEndInfo.Complications" #Complications="ngModel"
                                                maxlength="10" required>-->
                                                <CodeTypeValue CodeType="IVCPC"
                                                               id="FollicularPickupEndInfo.Complications"
                                                               [(ngModel)]="FollicularPickupEndInfo.Complications" SelectedValue="FollicularPickupEndInfo.Complications"
                                                               name="FollicularPickupEndInfo.Complications" required #Complication="ngModel">
                                                </CodeTypeValue>
                                                <!--<input type="text" class="form-control" placeholder="Endometrium Thickness">-->
                                                <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                                name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                                maxlength="100" required>-->
                                                <!--<small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                              </div>

                                            </div>


                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitProcedureDetails()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample4" *ngIf="PickupData2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFour">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
                                          Procedure Details
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp" [disabled]="Complication.errors?.required || Route.errors?.required || Batch.errors?.required || Needle.errors?.required || Anaesthesia.errors?.required  ">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>

                                  </div>


                                </div>

                                <div id="collapseFour" class="collapse show" aria-labelledby="headingFour" data-parent="#accordionExample4">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px">
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Anaesthesia </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">

                                                <!--<CodeTypeValue CodeType="IVFAT"
                                                               id="FollicularPickupEndInfo.AnaesthesiaType"
                                                               [(ngModel)]="FollicularPickupEndInfo.AnaesthesiaType" SelectedValue="FollicularPickupEndInfo.AnaesthesiaType"
                                                               name="FollicularPickupEndInfo.AnaesthesiaType" required #Anaesthesia="ngModel">
                                                </CodeTypeValue>-->

                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.AnaesthesiaType}}</label>

                                              </div>

                                            </div>


                                          </div>
                                        </div>

                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Needle Used </label>
                                              </div>:


                                              <div class="col-md-4 margin-tg-auto">

                                                <!--<CodeTypeValue CodeType="IVFPN"
                                                               id="FollicularPickupEndInfo.NeedleUsed"
                                                               [(ngModel)]="FollicularPickupEndInfo.NeedleUsed" SelectedValue="FollicularPickupEndInfo.NeedleUsed"
                                                               name="FollicularPickupEndInfo.NeedleUsed" required #Needle="ngModel">
                                                </CodeTypeValue>-->

                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.NeedleUsed}}</label>

                                              </div>

                                            </div>


                                          </div>
                                        </div>

                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Batch </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">

                                                <!--<input type="text" class="form-control" placeholder="Batch" [disabled]="true" id="FollicularPickupEndInfo.NeedleBatchName"
                                                [(ngModel)]="FollicularPickupEndInfo.NeedleBatchName"
                                                name="FollicularPickupEndInfo.NeedleBatchName" #Batch="ngModel"
                                                maxlength="100" required>-->

                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.NeedleBatchName}}</label>

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Route </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">

                                                <!--<CodeTypeValue CodeType="IVFPR"
                                                               id="FollicularPickupEndInfo.Route"
                                                               [(ngModel)]="FollicularPickupEndInfo.Route" SelectedValue="FollicularPickupEndInfo.Route"
                                                               name="FollicularPickupEndInfo.Route" required #Route="ngModel">
                                                </CodeTypeValue>-->

                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.Route}}</label>

                                              </div>

                                            </div>


                                          </div>
                                        </div>
                                        <div class="row my-profile-form">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                            <div class="row">
                                              <div class="col-md-3 text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="margin-bottom-0px">Complications </label>
                                              </div>:


                                              <div class="col-md-3 margin-tg-auto">

                                                <!--<CodeTypeValue CodeType="IVCPC"
                                                               id="FollicularPickupEndInfo.Complications"
                                                               [(ngModel)]="FollicularPickupEndInfo.Complications" SelectedValue="FollicularPickupEndInfo.Complications"
                                                               name="FollicularPickupEndInfo.Complications" required #Complication="ngModel">
                                                </CodeTypeValue>-->

                                                <label class="margin-bottom-0px">{{FollicularPickupEndInfo.Complications}}</label>

                                              </div>

                                            </div>


                                          </div>
                                        </div>


                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitPickUpSizes()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample5" *ngIf="PickupData2.ActivityStatus !=='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                          Follicle Size
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                                    </div>
                                    <!--<div class="col-md-6">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                    </div>-->
                                  </div>


                                </div>

                                <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="font-weight-normal font-size-14">Add/Edit</label>
                                          </div>
                                          <div class="col-md-3 text-align-right">
                                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                          </div>
                                        </div>

                                      </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px">

                                        <div class="row my-profile-form" *ngIf="CycleDetails.GradingModel=='Well Culture'">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Minimum Pickup Sizes </label>
                                              </div>


                                              <div class="col-md-3">

                                                <input type="text" class="form-control" placeholder="PickupSize" id="FollicularPickupEndInfo.MinPickupSize"
                                                       [(ngModel)]="FollicularPickupEndInfo.MinPickupSize"
                                                       name="FollicularPickupEndInfo.MinPickupSize" #Pickupsize="ngModel"
                                                       maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Pickupsize.valid && (Pickupsize.dirty || Pickupsize.touched) && Pickupsize.errors.required )"></small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Pickupsize.valid && Pickupsize.errors.pattern)">(only numbers are allowed)</small>

                                              </div>

                                            </div>


                                          </div>
                                        </div>

                                        <div class="row margin-top-10">
                                          <div class="col-md-12">

                                            <div class="table-component">
                                              <div class="table-responsive">


                                                <table class="table table-striped margin-left-zero width-50-new">

                                                  <tr>

                                                    <th class="font-weight-normal td-padding-tb background-primary">

                                                    </th>
                                                    <!--<th class="text-align-center">Day</th>-->
                                                    <th class="font-weight-normal td-padding-tb background-primary text-align-center">
                                                      Right
                                                    </th>


                                                    <th class="font-weight-normal td-padding-tb background-primary text-align-center">
                                                      Left
                                                    </th>
                                                    <!--<th class="text-align-center">Start Time</th>-->












                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                                      Follicles
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.RFollicleCount"
                                                             [(ngModel)]="FollicularPickupEndInfo.RFollicleCount"
                                                             name="FollicularPickupEndInfo.RFollicleCount" #Doctor="ngModel"
                                                             required />

                                                    </td>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.LFollicleCount"
                                                             [(ngModel)]="FollicularPickupEndInfo.LFollicleCount"
                                                             name="FollicularPickupEndInfo.LFollicleCount" #Doctor="ngModel"
                                                             required />
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                                      Aspirated
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.RFollicleAspirated"
                                                             [(ngModel)]="FollicularPickupEndInfo.RFollicleAspirated"
                                                             (ngModelChange)="ChangeRFollicle($event)"
                                                             name="FollicularPickupEndInfo.RFollicleAspirated" #Doctor="ngModel"
                                                             required />
                                                    </td>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.LFollicleAspirated"
                                                             [(ngModel)]="FollicularPickupEndInfo.LFollicleAspirated"
                                                             (ngModelChange)="ChangeLFollicle($event)"
                                                             name="FollicularPickupEndInfo.LFollicleAspirated" #Doctor="ngModel"
                                                             required />
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                                      Oocytes Retrieved
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.TotalRtOocytes"
                                                             [(ngModel)]="FollicularPickupEndInfo.TotalRtOocytes"
                                                             name="FollicularPickupEndInfo.TotalRtOocytes" #Doctor="ngModel"
                                                             required />
                                                    </td>
                                                    <td class="td-padding-tb">
                                                      <input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.TotalLtOocytes"
                                                             [(ngModel)]="FollicularPickupEndInfo.TotalLtOocytes"
                                                             name="FollicularPickupEndInfo.TotalLtOocytes" #Doctor="ngModel"
                                                             required />
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="td-padding-tb background-primary">
                                                      Total
                                                    </th>
                                                    <td class="td-padding-tb font-weight-bold">
                                                      <!--<input type="number" class="form-control"
                                                      min="1" max="10" id="FollicularPickupEndInfo.TotalOocytes"
                                                      [(ngModel)]="FollicularPickupEndInfo.TotalOocytes"
                                                      name="FollicularPickupEndInfo.TotalOocytes" #Doctor="ngModel"
                                                      required />-->
                                                      <label>{{FollicularPickupEndInfo.TotalRtOocytes+ FollicularPickupEndInfo.TotalLtOocytes}}</label>
                                                    </td>
                                                    <td class="td-padding-tb font-weight-bold">
                                                      <!--<input type="number" class="form-control"
                                                      min="1" max="10" />-->
                                                    </td>
                                                  </tr>
                                                </table>

                                              </div>
                                            </div>

                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved && PickupData2">
                          <form class="form " novalidate="" (ngSubmit)="onSubmitPickUpSizes()" #f="ngForm">
                            <div class="accordion margin-bottom-20px" id="accordionExample5" *ngIf="PickupData2.ActivityStatus =='Completed'">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingFive">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
                                          Follicle Size
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 ">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>

                                  </div>


                                </div>

                                <div id="collapseFive" class="collapse show" aria-labelledby="headingFive" data-parent="#accordionExample5">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">

                                      <div class="card-body padding-top-0px padding-bottom-0px">

                                        <div class="row my-profile-form" *ngIf="CycleDetails.GradingModel=='Well Culture'">
                                          <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                            <div class="row">
                                              <div class="col-md-3 padding-right-0px text-align-right margin-tg-auto ">
                                                <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Minimum Pickup Sizes </label>
                                              </div>


                                              <div class="col-md-3">

                                                <input type="text" class="form-control" placeholder="PickupSize" id="FollicularPickupEndInfo.MinPickupSize"
                                                       [(ngModel)]="FollicularPickupEndInfo.MinPickupSize"
                                                       name="FollicularPickupEndInfo.MinPickupSize" #Pickupsize="ngModel"
                                                       maxlength="5" pattern="^[\0-9,._\-?]*$" required>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Pickupsize.valid && (Pickupsize.dirty || Pickupsize.touched) && Pickupsize.errors.required )"></small>
                                                <small class="form-text text-danger"
                                                       *ngIf="(!Pickupsize.valid && Pickupsize.errors.pattern)">(only numbers are allowed)</small>

                                              </div>

                                            </div>


                                          </div>
                                        </div>

                                        <div class="row margin-top-10">
                                          <div class="col-md-12">

                                            <div class="table-component">
                                              <div class="table-responsive">


                                                <table class="table table-striped margin-left-zero width-50-new">

                                                  <tr>

                                                    <th class="font-weight-normal td-padding-tb background-primary">

                                                    </th>
                                                    <!--<th class="text-align-center">Day</th>-->
                                                    <th class="font-weight-normal td-padding-tb background-primary text-align-left">
                                                      Right
                                                    </th>


                                                    <th class="font-weight-normal td-padding-tb background-primary text-align-left">
                                                      Left
                                                    </th>
                                                    <!--<th class="text-align-center">Start Time</th>-->












                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                                      Follicles
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.RFollicleCount"
                                                             [(ngModel)]="FollicularPickupEndInfo.RFollicleCount"
                                                             name="FollicularPickupEndInfo.RFollicleCount" #Doctor="ngModel"
                                                             required />-->
                                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.RFollicleCount}}</label>
                                                    </td>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.LFollicleCount"
                                                             [(ngModel)]="FollicularPickupEndInfo.LFollicleCount"
                                                             name="FollicularPickupEndInfo.LFollicleCount" #Doctor="ngModel"
                                                             required />-->
                                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.LFollicleCount}}</label>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                                      Aspirated
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.RFollicleAspirated"
                                                             [(ngModel)]="FollicularPickupEndInfo.RFollicleAspirated"
                                                             (ngModelChange)="ChangeRFollicle($event)"
                                                             name="FollicularPickupEndInfo.RFollicleAspirated" #Doctor="ngModel"
                                                             required />-->
                                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.RFollicleAspirated}}</label>
                                                    </td>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.LFollicleAspirated"
                                                             [(ngModel)]="FollicularPickupEndInfo.LFollicleAspirated"
                                                             (ngModelChange)="ChangeLFollicle($event)"
                                                             name="FollicularPickupEndInfo.LFollicleAspirated" #Doctor="ngModel"
                                                             required />-->
                                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.LFollicleAspirated}}</label>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                                      Oocytes Retrieved
                                                    </th>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.TotalRtOocytes"
                                                             [(ngModel)]="FollicularPickupEndInfo.TotalRtOocytes"
                                                             name="FollicularPickupEndInfo.TotalRtOocytes" #Doctor="ngModel"
                                                             required />-->
                                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.TotalRtOocytes}}</label>
                                                    </td>
                                                    <td class="td-padding-tb">
                                                      <!--<input type="number" class="form-control text-align-end"
                                                             min="1" max="10" id="FollicularPickupEndInfo.TotalLtOocytes"
                                                             [(ngModel)]="FollicularPickupEndInfo.TotalLtOocytes"
                                                             name="FollicularPickupEndInfo.TotalLtOocytes" #Doctor="ngModel"
                                                             required />-->
                                                      <label class="margin-bottom-0px">{{FollicularPickupEndInfo.TotalLtOocytes}}</label>
                                                    </td>
                                                  </tr>
                                                  <tr>
                                                    <th rowspan="1" class="td-padding-tb background-primary">
                                                      Total
                                                    </th>
                                                    <td class="td-padding-tb font-weight-bold">
                                                      <!--<input type="number" class="form-control"
                                                      min="1" max="10" id="FollicularPickupEndInfo.TotalOocytes"
                                                      [(ngModel)]="FollicularPickupEndInfo.TotalOocytes"
                                                      name="FollicularPickupEndInfo.TotalOocytes" #Doctor="ngModel"
                                                      required />-->
                                                      <label>{{FollicularPickupEndInfo.TotalRtOocytes+ FollicularPickupEndInfo.TotalLtOocytes}}</label>
                                                    </td>
                                                    <td class="td-padding-tb font-weight-bold">
                                                      <!--<input type="number" class="form-control"
                                                      min="1" max="10" />-->
                                                    </td>
                                                  </tr>
                                                </table>

                                              </div>
                                            </div>

                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </form>
                        </div>

                        <div class="row margin-left-0px margin-top-15px">
                          <div class="col-md-12 padding-left-0px">
                            <div class="accordion margin-bottom-20px" id="accordionExample7">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="heading7">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapse7" aria-expanded="true" aria-controls="collapse7">
                                          Procedures/Tests
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="button"
                                              class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddTests()"
                                              name="upload" *ngIf="!FollicularPickupEndInfo.IsPickedUp">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                    <!--<div class="col-md-6">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                    </div>-->
                                  </div>


                                </div>

                                <div id="collapse7" class="collapse show" aria-labelledby="heading7" data-parent="#accordionExample7">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="font-weight-normal font-size-14">Add/Edit</label>
                                          </div>
                                          <div class="col-md-3 text-align-right">
                                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                          </div>
                                        </div>

                                      </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-lg-11 col-md-11 col-xs-11 padding-right-0px">
                                            <div class="table-component table-tests">
                                              <div class="table-responsive">


                                                <table class="table table-striped margin-left-zero width-50-new">

                                                  <tbody class="table-body">

                                                    <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                                                      <!--<td class="padding-top-4px padding-bottom-4px ">{{l.Date | date:'MMM-dd-yyyy'}}</td>
                                                      <td class="padding-top-4px padding-bottom-4px ">{{l.TestName}}</td>
                                                      <td class=" padding-top-4px padding-bottom-4px ">{{l.Comments}}</td>-->
                                                      <td class="padding-top-4px padding-bottom-4px padding-right-0px">{{RowIndex+1}}</td>
                                                      <td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                                        <div class="height-16px">
                                                          <label class="font-size-14 margin-bottom-0px">{{l.TestName}}</label>
                                                        </div>
                                                        <div class="row-height-17px">
                                                          <label class="font-size-12px margin-bottom-0px">Result : {{l.Result}}{{l.ResultUnits}}</label>
                                                        </div>
                                                        <div class="row-height-17px">
                                                          <label class="font-size-12px margin-bottom-0px">{{l.Comments}}</label>
                                                        </div>
                                                      </td>
                                                      <td class="padding-top-4px padding-bottom-4px">
                                                        <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                                                          <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                                        </a>-->
                                                        <div class="test-icons float-right">
                                                          <a (click)="delTEST(l)" title="Remove" *ngIf="!FollicularPickupEndInfo.IsPickedUp"><i class="fa fa-times color-Rejected delete-test-icon nav-link-hand"></i></a>
                                                          <a (click)="EditTest(l)" class="nav-link-hand education-navlink  color-Assign editicon edit-test-icon" title="Edit">
                                                            <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                                          </a>
                                                        </div>
                                                      </td>




                                                    </tr>

                                                  </tbody>
                                                </table>

                                              </div>
                                            </div>
                                          </div>
                                        </div>

                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>

                        <div class="row margin-left-0px margin-top-15px">
                          <div class="col-md-12 padding-left-0px">
                            <div class="accordion margin-bottom-20px" id="accordionExample8">
                              <div class="card margin-bottom-5px">
                                <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="heading8">
                                  <div class="row">
                                    <div class="col-md-4">
                                      <h5 class="mb-0 height-24px">
                                        <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapse8" aria-expanded="true" aria-controls="collapse8">
                                          Medicines
                                        </button>
                                      </h5>
                                    </div>
                                    <div class="col-md-8 " *ngIf="FollicularPickupEndInfo">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                      <button type="button"
                                              class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddMedicine()"
                                              name="upload" *ngIf="!FollicularPickupEndInfo.IsPickedUp">
                                        <i class="fas fa-plus font-size-11"></i>
                                      </button>
                                      <!--<button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>-->
                                    </div>
                                    <!--<div class="col-md-6">
                                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                      <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                    </div>-->
                                  </div>


                                </div>

                                <div id="collapse8" class="collapse show" aria-labelledby="heading8" data-parent="#accordionExample8">
                                  <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                                    <div class="card margin-bottom-0px">
                                      <!--<div class="card-header wh-header border-bottom-0px border-top-0 border-left-0 border-right-0 padding-bottom-0px">
                                        <div class="row">
                                          <div class="col-md-3">
                                            <label class="font-weight-normal font-size-14">Add/Edit</label>
                                          </div>
                                          <div class="col-md-3 text-align-right">
                                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                            <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                                          </div>
                                        </div>

                                      </div>-->
                                      <div class="card-body padding-top-0px padding-bottom-0px padding-left-0px padding-right-0px">
                                        <div class="col-lg-11 col-md-11 col-xs-11 col-11 padding-right-0px ">


                                          <div class="table-component">
                                            <div class="table-responsive">


                                              <table class="table table-striped margin-left-zero width-50-new">
                                                <!--<thead>
                                                                                    <tr>
                                                                                      <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 th-width-40px padding-top-4px padding-bottom-4px"></th>
                                                                                      <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 padding-top-4px padding-bottom-4px">

                                                                                      </th>

                                                                                      <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                                </th>
                                                <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                                </th>
                                                <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                                </th>


                                                                                      <th class="font-weight-normal  background-primary padding-top-4px padding-bottom-4px">

                                                                                      </th>











                                                                                    </tr>
                                                                                  </thead>-->
                                                <tbody class="table-body">

                                                  <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                                                    <td class="padding-top-4px padding-bottom-4px ">{{RowIndex+1}}</td>
                                                    <!--<td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                                      <div class="height-16px" >
                                                        <label class="font-size-14 margin-bottom-0px">{{l.MedicineName}}</label>
                                                      </div>
                                                      <div class="height-16px" >
                                                        <label class="font-size-12px margin-bottom-0px">{{l.Dose}}</label>
                                                      </div>
                                                      <div class="height-16px" >
                                                        <label class="font-size-12px margin-bottom-0px">{{l.DosageForm}}</label>
                                                      </div>
                                                      <div class="height-16px" >
                                                        <label class="font-size-12px margin-bottom-0px">{{l.Instructions}}</label>
                                                      </div>
                                                      <div class="height-16px" >
                                                        <label class="font-size-12px margin-bottom-0px">{{l.Remarks}}</label>
                                                      </div>

                                                    </td>-->
                                                    <td class="padding-top-4px padding-bottom-4px padding-left-4"><label class="font-size-12px margin-bottom-0px">{{l.MedicineName}}</label></td>
                                                    <td class=" padding-top-4px padding-bottom-4px ">{{l.Dosage}}{{l.DurationType}}</td>
                                                    <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.DosageForm}}</td>
                                                    <td class=" padding-top-4px padding-bottom-4px ">{{l.MedicineInstructions}}</td>

                                                    <td class="padding-top-4px padding-bottom-4px ">
                                                      <div class="test-icons float-right">
                                                        <a (click)="delMedicine(l)" title="Remove" *ngIf="!FollicularPickupEndInfo.IsPickedUp"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                                        <a (click)="EditMedicine(l)" class="nav-link-hand education-navlink  color-Assign" title="Edit" *ngIf="!FollicularPickupEndInfo.IsPickedUp">
                                                          <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                                        </a>
                                                      </div>
                                                    </td>
                                                    <!--<td class="padding-top-4px padding-bottom-4px">


                                                    </td>-->




                                                  </tr>

                                                </tbody>
                                              </table>

                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-md-3 padding-left-0px background-white" *ngIf="ScanDetails">
          <div class="row">
            <div class="position-fixed-Activities">

              <div class="col-md-12">
                <div class="card">
                  <div class="card-header wh-header  padding-left-0px padding-right-0px border-bottom-0px padding-top-0px">
                    <ul class="nav nav-tabs nav-tab-ivf margin-top-3px" id="tabContent">
                      <li class="active nav-link-hand margin-right-5px"><a class="nav-item-ivf active" href="#details" data-toggle="tab"> Activities</a></li>
                      <li class="nav-link-hand margin-right-5px"><a class="nav-item-ivf" href="#access-security" data-toggle="tab">Forms</a></li>

                    </ul>
                  </div>
                  <div class="card-body padding-all-0px">
                    <div class="tab-content">
                      <div class="tab-pane active" id="details">
                        <!--<div class="card">
                        <div class="card-body padding-all-0px">
                          <div class="row margin-right-0px margin-left-0px margin-top-5px">
                            <div class="col-md-9 margin-left-15px padding-right-0px padding-left-0px ">
                              <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                            </div>
                            <div class="col-md-2">
                              <button type="button" class="btn btn-ivf-new  btn-sm background-primary border-all-secondary" tooltip="Add"><i class="fas fa-plus nav-link-hand"></i></button>
                            </div>
                          </div>

                          <div class="row margin-top-10 margin-left-0px">
                            <div class="col-md-12">
                              <div class="table-component">
                                <div class="table-responsive overflow-x">


                                  <table class="table table-striped margin-left-zero"
                                         cols="auto,2*,*,*,*,*,*,*">

                                    <thead class="">
                                      <tr>

                                        <th class="td-width-103px font-weight-normal td-padding-tb">
                                          Date
                                        </th>

                                        <th class="font-weight-normal td-padding-tb">
                                          Remarks
                                        </th>


                                        <th class="text-align-center font-weight-normal td-padding-tb">
                                          Status
                                        </th>









                                                            </tr>
                                                          </thead>

                                                          <tbody class="table-body">
                                                            <tr>

                                                              <td class="padding-right-0px td-padding-tb align-top font-size-12px">
                                                                13-JUN-19




                                                              </td>






                                                              <td class="td-padding-tb">
                                                                <div>Day 4 Grading</div>
                                                                <div class="td-padding-tb td-elipsis2">Anim pariatur cliche reprehenderit, enim eiusmod high life accusamus terry richardson ad squid. 3 wolf moon officia aute, non cupidatat skateboard dolor brunch. Food truck quinoa nesciunt laborum eiusmod.</div>
                                                              </td>

                                                              <td class="td-padding-tb text-align-center align-top">
                                                                <i class="fas fa-circle light-gray-badge nav-link-hand  ">
                                                                </i>
                                                              </td>

                                                            </tr>

                                                          </tbody>

                                                        </table>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </div>-->
                        <div *ngIf="SelectedpatientDetails.EggSourceType=='DONOR' || SelectedpatientDetails.EggSourceType=='Donor'">
                          <cycleactivities [ActorCode]="SelectedpatientDetails.ActorCode" [CycleCode]="SelectedpatientDetails.PickUpTreatmentCycle" [LMPDate]="LMPDate" ActivityName="PickupEgg" [CanLoadReport]='CanLoadReport'></cycleactivities>
                        </div>
                        <div *ngIf="SelectedpatientDetails.EggSourceType=='Self'">
                          <cycleactivities [ActorCode]="SelectedpatientDetails.ActorCode" [CycleCode]="SelectedpatientDetails.PickUpTreatmentCycle" [LMPDate]="LMPDate" ActivityName="PickupSelf" [CanLoadReport]='CanLoadReport'></cycleactivities>
                        </div>

                        <!--<cycleactivities [ActorCode]="SelectedpatientDetails.ActorCode" [CycleCode]="SelectedpatientDetails.PickUpTreatmentCycle" [LMPDate]="LMPDate"></cycleactivities>-->
                      </div>
                      <div class="tab-pane" id="access-security">
                        <div class="card">
                          <div class="card-body padding-bottom-0px padding-top-0px">
                            <div class="row">
                              <div class="col-md-12">
                                <div class="row">
                                  <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                    <div class="row">


                                      <div class="col-md-12">
                                        <CustomDataByRequestType RequestedType="FDActorReports" ActorCode={{ActorCodeLoad()}}
                                                                 id="CurrentFdActorReportsDocController.TemplateName" SelectedValue=""
                                                                 [(ngModel)]="SelectedReport"
                                                                 (keyChange)="onAssignedToActorCode($event)"
                                                                 name="CurrentFdActorReportsDocController.TemplateName">
                                        </CustomDataByRequestType>
                                        <!--<CodeTypeValue CodeType="RELTP"></CodeTypeValue>-->


                                      </div>
                                      <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                                        <div *ngIf="fo && fo.AutoSections" class="margin-top-10">


                                          <div class="row card margin-left-0px margin-right-0px margin-bottom-5px" *ngFor="let section of  fo.AutoSections;let RowIndex = index">
                                            <div [id]="'accordion'+RowIndex">
                                              <div [ngSwitch]="section.SectionType">
                                                <div class="card-header wh-header font-size-16px  padding-top-0px padding-bottom-0px border-left-clinical padding-l-8px padding-right-0px font-weight-normal2 font-size-16px" [id]="'heading'+RowIndex">
                                                  <h5 class="mb-0">
                                                    <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" [attr.data-target]="'#collapse_cre'+RowIndex"
                                                            aria-expanded="true" [attr.aria-controls]="'collapse_cre'+RowIndex">
                                                      {{section.Data.Title}}

                                                    </button>
                                                  </h5>

                                                </div>
                                                <div [id]="'collapse_cre'+RowIndex" class="collapse show collapse-show3" [attr.aria-labelledby]="'heading'+RowIndex"
                                                     [attr.data-parent]="'#accordion'+RowIndex">
                                                  <div class="card-body padding-bottom-19px padding-right-0px padding-top-0px">

                                                    <div class="row" *ngSwitchCase="'AttrVal'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px" *ngFor="let field of  section.Fields">


                                                        <div [ngSwitch]="field.Data.ValueType">
                                                          <div class="row" *ngSwitchCase="'Bool'">
                                                            <auto-gen-bool class="col-md-12" [Data]="field" [field]="field.Data"
                                                                           mode="view2">
                                                            </auto-gen-bool>
                                                          </div>
                                                          <div class="row" *ngSwitchCase="'List'">
                                                            <auto-gen-list class="col-md-12 padding-l-0px padding-right-0px" [Data]="field" [field]="field.Data"
                                                                           mode="view2">
                                                            </auto-gen-list>
                                                          </div>
                                                          <div class="row margin-top-5px" *ngSwitchCase="'Text'">
                                                            <auto-gen-text class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-text>
                                                          </div>
                                                          <div class="row margin-top-5px" *ngSwitchCase="'CVS'">
                                                            <auto-gen-cvs class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-cvs>
                                                          </div>
                                                          <div class="row" *ngSwitchCase="'Date'">
                                                            <auto-gen-date class="col-md-12" [field]="field.Data" mode="view2"></auto-gen-date>
                                                          </div>
                                                          <div class="row padding-bottom-10px" *ngSwitchCase="'Grid'">
                                                            <!--<label>Grid: {{field.Title}}</label>-->
                                                            <auto-gen-grid class="col-md-12" [field]="field" mode="view2"></auto-gen-grid>
                                                          </div>

                                                          <div class="row" *ngSwitchDefault>




                                                          </div>





                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row" *ngSwitchCase="'Text'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px">
                                                        <!--*ngFor="let field of  section.Fields"-->

                                                        <div class="row">
                                                          <div class="col-md-12 " *ngFor="let field of section.Data.Fields">
                                                            <div class="row" *ngIf="field.ValueType=='Text'">

                                                              <div class="col-md-11 padding-left-0px padding-right-0px">

                                                                <textarea class="form-control3 size-2 width-inherit margin-top-5px margin-left-5px" placeholder="Remarks"
                                                                          [ngModelOptions]="{standalone: true}"
                                                                          [(ngModel)]="field.Value" maxlength="600"></textarea>

                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row" *ngSwitchCase="'Image'">
                                                      <div class="col-md-12 padding-l-0px padding-right-0px">
                                                        <!--*ngFor="let field of  section.Fields-->

                                                        <div class="row">
                                                          <div class="col-md-12">
                                                            <div class="table-component">
                                                              <div class="table-responsive">


                                                                <table class="table table-striped margin-left-zero">

                                                                  <!--<thead class="">
                                                                    <tr>
                                                                      <th class="min-width-0px width-57px padding-top-4px padding-bottom-4px"></th>

                                                                      <th class="width-53px padding-top-4px padding-bottom-4px">#</th>
                                                                      <th class="width-178px padding-top-4px padding-bottom-4px">Title</th>
                                                                      <th class="padding-top-4px padding-bottom-4px">Image</th>

                                                                      <th class="padding-top-4px padding-bottom-4px">Comments</th>
                                                                      <th class="padding-top-4px padding-bottom-4px"></th>
                                                                    </tr>
                                                                  </thead>-->
                                                                  <tbody class="table-body">

                                                                    <tr *ngFor="let field of section.Data.Fields; let RowIndex = index ">
                                                                      <!--<td class="padding-top-0px padding-bottom-0px ">

                                                                        <input type="checkbox" [(ngModel)]="field.IsSelected" />
                                                                        <i class="input-helper"></i>

                                                                      </td>-->
                                                                      <td class="padding-top-0px padding-bottom-0px ">{{RowIndex+1}}</td>

                                                                      <td class="padding-top-0px padding-bottom-0px ">
                                                                        <!--<input class="form-control " [(ngModel)]="field.Title" type="text" [ngModelOptions]="{standalone: true}" />-->
                                                                        <div><label class="margin-bottom-0px">{{field.Title}}</label></div>
                                                                        <div><label class="margin-bottom-0px"> {{field.Remarks}}</label></div>
                                                                      </td>
                                                                      <td class="padding-top-0px padding-bottom-0px padding-left-5px">

                                                                        <!--<div *ngIf="!field.HasImage">
                                                                          <button class="button-service-save font-size-16px color-secondary nav-link-hand" title="Save">
                                                                            <i class="fas fa-ellipsis-h"></i>
                                                                          </button>
                                                                        </div>-->
                                                                        <div *ngIf="field.HasImage">
                                                                          <img class="img-circle-56 font-size-12px" [src]="field.ImageFile" onError="this.src='dummy.jpg';">
                                                                          <!--<button type="button" class="btn  btn-sm button-new-health margin-top-left" tooltip="Add" (click)="openDocContent(field)" *ngIf="field?.IsSelected"><i class="fas fa-plus nav-link-hand"></i></button>-->

                                                                        </div>
                                                                      </td>
                                                                      <!--<td class="padding-top-0px padding-bottom-0px">

                                                                        {{field.Remarks}}

                                                                      </td>-->
                                                                      <!--<td class="text-align-right padding-top-0px padding-bottom-0px">

                                                                        <a class="nav-link-hand font-size-20px margin-left-10px" title="Remove" *ngIf="field?.IsSelected"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>

                                                                      </td>-->



                                                                    </tr>

                                                                  </tbody>

                                                                </table>

                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <!--<label>{{f.Title}}</label>
                                                    <label class="margin-left-auto"></label>-->

                                                  </div>
                                                </div>
                                              </div>
                                            </div>
                                            <!--<div *ngFor="let l of CurrentFdActorReportsDocController">
                                              <label>{{l.TemplateName}}</label>
                                            </div>-->


                                          </div>

                                        </div>
                                      </div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>





      </div>
    </div>

  </div>
  <div class="job-posts placements agreements margin-top-service-30px top-link2 overscrollbehaviour">


    <div class="row" *ngIf="displayPatientdata">
      <div class="col-md-3 col-12 padding-right-0px">

        <div class="position-fixed-sm-scans border-right2 padding-right-5px">
          <div class="card">

            <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-0">
              <div class="row margin-top10px margin-left-20px  nav-link-hand">
                <div class="col-md-10 col-10 padding-left-0px">
                  <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                    Follicular Pickup
                  </label>
                </div>
                <div class="col-md-1 col-1">
                  <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackTodashboard2()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
                </div>




              </div>




            </div>
            <div class="card-body padding-top-0px padding-left-0px padding-right-0px bk-color-light padding-right-0px padding-bottom-0px">
              <div class="row border-top margin-left-0px margin-right-0px margin-bottom-5px">
                <div class="col-md-1 col-1 padding-right-0px" (click)="DecrementDate()">
                  <a title="Previous" class="nav-link-hand">
                    <i class="fas fa-caret-left margin-top-5px font-size-28px color-secondary-hover"></i>
                  </a>
                </div>
                <div class="col-md-5 col-5 col-sm-4 padding-right-12px my-profile-form  padding-left-5px">
                  <div class="date-form margin-top-5px form-group margin-bottom-0px">
                    <input class="form-control" placeholder="From Date" [minDate]="minDate" [maxDate]="maxDate"
                           name="SelectedFromDate" [(ngModel)]="SelectedFromDate" (ngModelChange)="dataChanged($event)" ngbDatepicker #d="ngbDatepicker">

                    <a (click)="d.toggle()" class="nav-link-hand">
                      <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                    </a>

                  </div>



                </div>

                <div class="col-md-1 col-1 padding-left-0px padding-right-0px" (click)="IncrementDate()">
                  <a title="Next" class="nav-link-hand">
                    <i class="fas fa-caret-right margin-top-5px font-size-28px color-secondary-hover"></i>
                  </a>
                </div>
              </div>
              <div class="row margin-right-0px margin-left-0px">
                <div class="col-md-11 col-11 margin-bottom-10px margin-top-10 margin-left-10px padding-right-0px padding-left-10px">
                  <search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>
                  <!--<input type="search"  [title]="searchTitle"  (change)="criteriaChange($event)" class="form-control padding-bottom-2px width-230px margin-top-10 margin-bottom-10px" placeholder="Search....">-->
                </div>
                <div class="col-md-2" hidden>
                  <button type="button" class="btn btn-primary btn-sm" tooltip="Add" hidden><i class="fas fa-plus nav-link-hand"></i></button>
                </div>
                <div class="col-md-1 padding-left-8px" hidden>
                  <a class="nav-link-hand education-navlink" tooltip="Edit">
                    <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                  </a>

                </div>
                <div class="col-md-1 padding-left-8px" hidden>
                  <a class="nav-link-hand education-navlink" tooltip="Delete">
                    <span class="badge font-size-14">
                      <i class="far fa-trash-alt"></i>
                    </span>
                  </a>
                </div>

              </div>
              <div>
                <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                  <div *ngIf="isRequesting">
                    <div class="loader-text">
                      <div class="loader-text2">

                        <div class="lds-facebook">
                          <div></div>
                          <div></div>
                          <div></div>
                        </div>
                        <div class="margin-top-20px margin-left-5px">
                          <label class="margin-bottom-0px font-size-12px"> Please Wait...</label>
                        </div>
                        <!--Loading Please Wait...-->
                      </div>
                    </div>
                    <!--<div class="loadernew"></div>-->


                  </div>
                  <div *ngIf="!isRequesting">
                    <div class="row border-bottom row-for-scans margin-left16px nav-link-hand" (click)="Selectedpatient2(l)" *ngFor="let l of pdata">
                      <div class="col-md-2 col-2 padding-left-0px " (click)="Selectedpatient2(l)">


                        <!--<img class="user-image-circle-65px img2 margin-left-6px" src="dummy.jpg">-->

                        <img class="user-image-circle-65px img2 margin-left-6px" [src]="l.OwnerPatientImageFile" onError="this.src='dummy.jpg';">

                      </div>
                      <div class="col-md-7 col-7 margin-top-5px padding-right-0px padding-left-0px">
                        <div class="row row-height-17px">
                          <div class="col-md-12 col-12">
                            <label class="margin-bottom-0px">{{l.OwnerName}}</label>
                          </div>

                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-12 col-12">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerAgeYears}},{{l.OwnerFormattedCode}}</label>
                          </div>
                        </div>
                        <div class="row row-height-17px">
                          <div class="col-md-4 col-4">
                            <label class="font-size-12px margin-bottom-0px light-gray-new">{{l.OwnerTelephone1}}</label>
                          </div>
                        </div>

                      </div>
                      <div class="col-md-3  col-3 padding-left-0px margin-top-5px">
                        <div class="text-align-center">
                          <i class="fas fa-check-circle color-icon-completed "></i>
                        </div>
                        <div class="text-align-center"><label class="font-size-12px">10:30</label></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </div>
        </div>

      </div>
    </div>
    <div class="row margin-top-sm-13" *ngIf="displayscansdata">
      <div class="col-12">
        <div class="card">
          <div class="card-header wh-header header3 padding-right-0px bk-color-light padding-bottom-0px border-bottom-1px">
            <div class="row margin-top10px margin-left-20px  nav-link-hand">
              <div class="col-md-10 col-10 padding-left-0px">
                <div class="row">
                  <div class="col-md-7 col-7">
                    <label class="wh-header font-weight-normal card-title-schedule-bl border-radius-4px padding-top-0px padding-left-7px padding-bottom-0px margin-bottom-0px bk-color-light">
                      Follicular Pickup
                    </label>
                  </div>
                  <div class="col-md-6 col-5 margin-top-3px padding-left-0px padding-right-0px text-align-right" *ngIf="FollicularPickupEndInfo">
                    <a class="nav-link-hand patientreg-link  margin-bottom-8px font-weight-normal" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>
                    <!--<a class="nav-link-hand patientreg-link row-card-a margin-bottom-8px font-weight-normal display-edit" (click)="pickup()" title="Is Pickup Confirmed" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Is Pickup Confirmed</a>-->
                  </div>
                </div>


              </div>
              <div class="col-md-1 col-1">
                <a class="nav-link-hand margin-top-auto margin-bottom margin-left-auto" title="Back To Ivf Bench" (click)="BackToPatientdata()"><i class="fas fa-angle-double-left font-size-19px margin-top-5px"></i></a>
              </div>




            </div>




          </div>
          <div class="card-body padding-all-0px">
            <div class="row margin-top-10" *ngIf="SelectedpatientDetails">
              <div class="col-md-1 col-2 ">
                <img class=" margin-left-6px image-width-scans width-small-52px" [src]="SelectedpatientDetails.EggPatientImageFile" onError="this.src='dummy.jpg';">
                <!--<img class=" margin-left-6px image-width-scans width-small-52px" src="dummy.jpg">-->
              </div>
              <div class="col-md-4 col-5 ">
                <div class="row row-height-17px margin-left-0px">

                  <label class="margin-bottom-0px font-weight-normal color-secondary font-size-14">{{SelectedpatientDetails.EggName}} </label>
                </div>
                <div class="row row-height-17px margin-left-0px" *ngIf="SelectedpatientDetails.EggSourceType=='DONOR'">
                  <div class="col-md-12 white-space-nowrap padding-left-0px padding-right-0px">
                    <label class="margin-bottom-0px font-weight-normal  font-size-12px color-owner">(of : {{SelectedpatientDetails.OwnerName}}) </label>
                  </div>
                </div>

                <div class="row row-height-17px">
                  <div class="col-md-12">
                    <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggAgeYears}},{{SelectedpatientDetails.EggFormattedCode}}</label>
                  </div>
                </div>
                <div class="row row-height-17px">
                  <div class="col-md-4">

                    <label class="font-size-12px margin-bottom-0px font-weight-normal">{{SelectedpatientDetails.EggTelephone1}}</label>
                  </div>
                </div>
              </div>
              <div class="offset-md-2  col-5 padding-left-0px col-md-4 text-align-right padding-right-0px">
                <div class="row font-size-12px">
                  <div class="col-md-6 col-6 padding-right-9px text-align-right-small">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">Check In </label>
                  </div>:
                  <div class="col-md-5 col-5 padding-right-0px padding-left-5px text-align-right" *ngIf="PickupData2">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">{{PickupData2.LastUpdatedTime | date: 'hh:mm a'}}</label>
                  </div>
                </div>
                <div class="row font-size-12px">
                  <div class="col-md-6 col-6 padding-right-9px text-align-right-small">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">Status </label>
                  </div>:
                  <div class="col-md-5 col-5 padding-right-0px padding-left-5px text-align-right" *ngIf="PickupData2">
                    <label class="font-weight-normal font-size-12px margin-bottom-0px">{{PickupData2.ActivityStatus}}</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row margin-top-10">
              <div class="col-12">
                <div class="chatsd product-chart-wrapper product-chat-width-100 agreement-chart-wrapper ps ps2 padding-lrt " data-ps-id="dfsfsde">
                  <div *ngIf="FollicularPickupEndInfo">
                    <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">



                      <div class="accordion" id="accordionExample">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingOne">
                            <div class="row">
                              <div class="col-md-4 col-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                    Ovulation Trigger
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-8 col-8">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!SelectedpatientDetails.IsReadyForPickup" hidden>Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                              </div>
                            </div>


                          </div>

                          <div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionExample">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-15px padding-right-5px">

                              <div class="row my-profile-form margin-top-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px margin-top-3px">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Trigger Date </label>
                                    </div>:
                                    <div class="col-7 margin-top-3px">
                                      <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.OvulationTriggerDate}}</label>

                                    </div>



                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">



                                    <div class="col-md-3 col-4 margin-top-3px">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Trigger Time </label>


                                    </div>:
                                    <div class="col-5 margin-top-3px">
                                      <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.OvulationTriggerTime|date: 'mediumTime'}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right margin-top-3px ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Medicine </label>
                                    </div>:


                                    <div class="col-md-3 col-7 margin-top-3px">


                                      <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.MedicineName}}</label>


                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">

                                    <div class="col-md-3 col-4 margin-top-3px">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Dose </label>


                                    </div>:
                                    <div class="col-4 margin-top-3px">
                                      <label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.Dosage}}</label>

                                    </div>



                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right margin-top-3px">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Batch</label>
                                    </div>:
                                    <div class="col-4 margin-top-3px">
                                      <!--<label class="margin-bottom-0px " *ngIf="FollicularPickupEndInfo">{{FollicularPickupEndInfo.Dosage}}</label>-->

                                    </div>


                                  </div>


                                </div>
                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved">
                    <form class="form " novalidate="" (ngSubmit)="onSubmitSchedule()" #f="ngForm">
                      <div class="accordion" id="accordionExample2">

                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingTwo">
                            <div class="row">
                              <div class="col-md-4 col-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
                                    Schedule
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-8 col-8">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                              </div>
                              <!--<div class="col-md-6">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto">Clear</button>
                                <button type="submit" class="btn font-size-13px actions-btn-prime margin-right-auto">Save</button>
                              </div>-->
                            </div>


                          </div>

                          <div id="collapseTwo" class="collapse show" aria-labelledby="headingTwo" data-parent="#accordionExample2">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-15px padding-right-5px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-0px">
                                  <div class="row">



                                    <div class="col-md-3 col-4 margin-top-3px">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Planned Time</label>


                                    </div>:
                                    <div class="col-7 margin-top-3px">
                                      <label class="margin-bottom-0px ">{{FollicularPickupEndInfo.OvumPlannedPickupTime}}</label>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-top-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px  margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Actual Date </label>
                                    </div>




                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-7px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">



                                    <div class="col-md-3 col-11">

                                      <div class="date-form">
                                        <input class="form-control" placeholder=" Date" [minDate]="minDate" [maxDate]="maxDate"
                                               name="dp1" [(ngModel)]="OvumPickupdate" ngbDatepicker #d1="ngbDatepicker" #DateOfBirth="ngModel">
                                        <small class="form-text text-danger"
                                               *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>
                                        <a (click)="d1.toggle()" class="nav-link-hand">
                                          <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                                        </a>

                                      </div>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-10px">
                                  <div class="row">
                                    <div class="col-md-3 col-6 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Actual Time </label>
                                    </div>


                                    <div class="col-md-3 col-3">


                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">

                                    <div class="col-md-3 col-11">

                                      <input type="time" class="form-control" id="FollicularPickupEndInfo.OvumPickupTime" placeholder="Trigger Time"
                                             [(ngModel)]="FollicularPickupEndInfo.OvumPickupTime"
                                             name="FollicularPickupEndInfo.OvumPickupTime" pattern="^[\sa-zA-Z0-9,._\-?]*$" #ActivityTime="ngModel" />
                                      <!--id="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.CounsellingDoctor"
                                      name="CurrentEditCounsellingPalnRequest.CounsellingDoctor" #Doctor="ngModel"
                                      maxlength="100" required>-->
                                      <!--<small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && (Doctor.dirty || Doctor.touched) && Doctor.errors.required )">(Field cannot be left blank)</small>
                                      <small class="form-text text-danger"
                                             *ngIf="(!Doctor.valid && Doctor.errors.pattern)">(special characters are not allowed)</small>-->

                                    </div>




                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>

                      </div>
                    </form>
                  </div>
                  <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved">
                    <form class="form " novalidate="" (ngSubmit)="onSubmitTeam()" #f="ngForm">
                      <div class="accordion" id="accordionExampletest">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingtest">
                            <div class="row">
                              <div class="col-md-4 col-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsetest" aria-expanded="true" aria-controls="collapsetest">
                                    Team
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-8 col-7 padding-right-0px" *ngIf="FollicularPickupEndInfo">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                              </div>
                            </div>


                          </div>

                          <div id="collapsetest" class="collapse show" aria-labelledby="headingtest" data-parent="#accordionExampletest">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-15px padding-right-5px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Surgeon</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CustomDataByRequestType RequestedType="SURGEON_LIST"
                                                               id="FollicularPickupEndInfo.Surgeon" SelectedValue="FollicularPickupEndInfo.Surgeon"
                                                               [(ngModel)]="FollicularPickupEndInfo.Surgeon" (keyChange)="onAssignedToActorCodesurgeon($event)"
                                                               name="FollicularPickupEndInfo.Surgeon" required>
                                      </CustomDataByRequestType>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Asst.Surgeon</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CustomDataByRequestType RequestedType="ASSISTANT_SURGEON_LIST"
                                                               id="FollicularPickupEndInfo.AsstSurgeon" SelectedValue=""
                                                               [(ngModel)]="FollicularPickupEndInfo.AsstSurgeon" (keyChange)="onAssignedToActorCodeAsstSurgeon($event)"
                                                               name="FollicularPickupEndInfo.AsstSurgeon" required>
                                      </CustomDataByRequestType>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Anaesthetist</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CustomDataByRequestType RequestedType="ANAESTHETIST_LIST"
                                                               id="FollicularPickupEndInfo.Anesthesiologist" SelectedValue="FollicularPickupEndInfo.Anesthesiologist"
                                                               [(ngModel)]="FollicularPickupEndInfo.Anesthesiologist" (keyChange)="onAssignedToActorCodeAnaesthetist($event)"
                                                               name="FollicularPickupEndInfo.Anesthesiologist" required>
                                      </CustomDataByRequestType>
                                      <!--name="CurrentEditCounsellingPalnRequest.Concerns"
                                      [(ngModel)]="CurrentEditCounsellingPalnRequest.Concerns" required minlength="1" maxlength="100"
                                      #addconcerns_text="ngModel"-->
                                      <!--<small class="form-text text-danger"
                                      *ngIf="(!addconcerns_text.valid && (addconcerns_text.dirty || addconcerns_text.touched))">(Required)</small>-->

                                    </div>
                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved">
                    <form class="form " novalidate="" (ngSubmit)="onSubmitProcedureDetails()" #f="ngForm">
                      <div class="accordion" id="accordionExamplemedicine">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingmedicine">
                            <div class="row">
                              <div class="col-md-4 col-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsemedicine" aria-expanded="true" aria-controls="collapsemedicine">
                                    Procedure Details
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-8 col-7 padding-right-0px">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                              </div>
                            </div>


                          </div>

                          <div id="collapsemedicine" class="collapse show" aria-labelledby="headingmedicine" data-parent="#accordionExamplemedicine">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-15px padding-right-5px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Anaesthesia</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="IVFAT"
                                                     id="FollicularPickupEndInfo.AnaesthesiaType"
                                                     [(ngModel)]="FollicularPickupEndInfo.AnaesthesiaType" SelectedValue="FollicularPickupEndInfo.AnaesthesiaType"
                                                     name="FollicularPickupEndInfo.AnaesthesiaType">
                                      </CodeTypeValue>


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Needle Used</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="IVFPN"
                                                     id="FollicularPickupEndInfo.NeedleUsed"
                                                     [(ngModel)]="FollicularPickupEndInfo.NeedleUsed" SelectedValue="FollicularPickupEndInfo.NeedleUsed"
                                                     name="FollicularPickupEndInfo.NeedleUsed">
                                      </CodeTypeValue>


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Batch</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <input type="text" class="form-control" placeholder="Batch" [disabled]="true" id="FollicularPickupEndInfo.NeedleBatchName"
                                             [(ngModel)]="FollicularPickupEndInfo.NeedleBatchName"
                                             name="FollicularPickupEndInfo.NeedleBatchName" #NeedleName="ngModel"
                                             maxlength="100" required>


                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Route</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="IVFPR"
                                                     id="FollicularPickupEndInfo.Route"
                                                     [(ngModel)]="FollicularPickupEndInfo.Route" SelectedValue="FollicularPickupEndInfo.Route"
                                                     name="FollicularPickupEndInfo.Route">
                                      </CodeTypeValue>

                                    </div>
                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-4 padding-right-0px text-align-right">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px">Complications</label>
                                    </div>


                                  </div>


                                </div>
                              </div>
                              <div class="row my-profile-form margin-bottom-3px">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-7px">
                                  <div class="row">


                                    <div class="col-md-4 col-11 padding-right-0px">
                                      <CodeTypeValue CodeType="IVCPC"
                                                     id="FollicularPickupEndInfo.Complications"
                                                     [(ngModel)]="FollicularPickupEndInfo.Complications" SelectedValue="FollicularPickupEndInfo.Complications"
                                                     name="FollicularPickupEndInfo.Complications">
                                      </CodeTypeValue>
                                    </div>
                                  </div>


                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div *ngIf="FollicularPickupEndInfo && FollicularPickupEndInfo.IsPickupApproved">
                    <form class="form " novalidate="" (ngSubmit)="onSubmitPickUpSizes()" #f="ngForm">
                      <div class="accordion" id="accordionExamplesizes">
                        <div class="card margin-bottom-5px">
                          <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingsizes">
                            <div class="row">
                              <div class="col-md-4 col-4">
                                <h5 class="mb-0 height-24px">
                                  <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsesizes" aria-expanded="true" aria-controls="collapsesizes">
                                    Pickup Sizes
                                  </button>
                                </h5>
                              </div>
                              <div class="col-md-8 col-7 padding-right-0px">
                                <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                                <button type="submit" class="btn actions-btn-prime font-size-13px background-transparent-button color-new-button border-color-new float-right" *ngIf="!FollicularPickupEndInfo.IsPickedUp">Save <i class="far fa-save nav-link-hand font-size-14 "></i></button>
                              </div>
                            </div>


                          </div>

                          <div id="collapsesizes" class="collapse show" aria-labelledby="headingsizes" data-parent="#accordionExamplesizes">
                            <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-15px padding-right-5px">
                              <div class="row my-profile-form">
                                <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                                  <div class="row">
                                    <div class="col-md-3 col-5 padding-right-0px text-align-right margin-tg-auto ">
                                      <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Minimum Pickup Sizes </label>
                                    </div>


                                    <div class="col-md-3 col-6">

                                      <input type="number" class="form-control" placeholder="PickupSize" id="FollicularPickupEndInfo.MinPickupSize"
                                             [(ngModel)]="FollicularPickupEndInfo.MinPickupSize"
                                             name="FollicularPickupEndInfo.MinPickupSize" #NeedleName="ngModel"
                                             maxlength="100" required>

                                    </div>

                                  </div>


                                </div>
                              </div>
                              <div class="row margin-top-10">
                                <div class="col-md-12 col-12">

                                  <div class="table-component">
                                    <div class="table-responsive">


                                      <table class="table table-striped margin-left-zero width-50-new">

                                        <tr>

                                          <th class="font-weight-normal td-padding-tb background-primary">

                                          </th>
                                          <!--<th class="text-align-center">Day</th>-->
                                          <th class="font-weight-normal td-padding-tb background-primary text-align-center">
                                            Right
                                          </th>


                                          <th class="font-weight-normal td-padding-tb background-primary text-align-center">
                                            Left
                                          </th>
                                          <!--<th class="text-align-center">Start Time</th>-->












                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                            Follicles
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.RFollicleCount"
                                                   [(ngModel)]="FollicularPickupEndInfo.RFollicleCount"
                                                   name="FollicularPickupEndInfo.RFollicleCount" #Doctor="ngModel"
                                                   required />

                                          </td>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.LFollicleCount"
                                                   [(ngModel)]="FollicularPickupEndInfo.LFollicleCount"
                                                   name="FollicularPickupEndInfo.LFollicleCount" #Doctor="ngModel"
                                                   required />
                                          </td>
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                            Aspirated
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.RFollicleAspirated"
                                                   [(ngModel)]="FollicularPickupEndInfo.RFollicleAspirated"
                                                   (ngModelChange)="ChangeRFollicle($event)"
                                                   name="FollicularPickupEndInfo.RFollicleAspirated" #Doctor="ngModel"
                                                   required />
                                          </td>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.LFollicleAspirated"
                                                   [(ngModel)]="FollicularPickupEndInfo.LFollicleAspirated"
                                                   (ngModelChange)="ChangeLFollicle($event)"
                                                   name="FollicularPickupEndInfo.LFollicleAspirated" #Doctor="ngModel"
                                                   required />
                                          </td>
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="font-weight-normal td-padding-tb background-primary">
                                            Oocytes Retrieved
                                          </th>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.TotalRtOocytes"
                                                   [(ngModel)]="FollicularPickupEndInfo.TotalRtOocytes"
                                                   name="FollicularPickupEndInfo.TotalRtOocytes" #Doctor="ngModel"
                                                   required />
                                          </td>
                                          <td class="td-padding-tb">
                                            <input type="number" class="form-control text-align-end"
                                                   min="1" max="10" id="FollicularPickupEndInfo.TotalLtOocytes"
                                                   [(ngModel)]="FollicularPickupEndInfo.TotalLtOocytes"
                                                   name="FollicularPickupEndInfo.TotalLtOocytes" #Doctor="ngModel"
                                                   required />
                                          </td>
                                        </tr>
                                        <tr>
                                          <th rowspan="1" class="td-padding-tb background-primary">
                                            Total
                                          </th>
                                          <td class="td-padding-tb font-weight-bold">
                                            <!--<input type="number" class="form-control"
                                            min="1" max="10" id="FollicularPickupEndInfo.TotalOocytes"
                                            [(ngModel)]="FollicularPickupEndInfo.TotalOocytes"
                                            name="FollicularPickupEndInfo.TotalOocytes" #Doctor="ngModel"
                                            required />-->
                                            <label>{{FollicularPickupEndInfo.TotalRtOocytes+ FollicularPickupEndInfo.TotalLtOocytes}}</label>
                                          </td>
                                          <td class="td-padding-tb font-weight-bold">
                                            <!--<input type="number" class="form-control"
                                            min="1" max="10" />-->
                                          </td>
                                        </tr>
                                      </table>

                                    </div>
                                  </div>

                                </div>
                              </div>

                            </div>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                  <div class="accordion" id="accordionExampletestnew">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingtestnew">
                        <div class="row">
                          <div class="col-md-4 col-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsetestnew" aria-expanded="true" aria-controls="collapsetestnew">
                                Procedures/Tests
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 col-7 padding-right-0px">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddTests()"
                                    name="upload" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                          </div>
                        </div>


                      </div>

                      <div id="collapsetestnew" class="collapse show" aria-labelledby="headingtestnew" data-parent="#accordionExampletestnew">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row">
                            <div class="col-11 padding-right-0px">
                              <div class="table-component table-tests">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero width-50-new">

                                    <tbody class="table-body">

                                      <tr *ngFor="let l of CurrentIvfCycleTestByCodeController ; let RowIndex = index ">
                                        <!--<td class="padding-top-4px padding-bottom-4px ">{{l.Date | date:'MMM-dd-yyyy'}}</td>
                                        <td class="padding-top-4px padding-bottom-4px ">{{l.TestName}}</td>
                                        <td class=" padding-top-4px padding-bottom-4px ">{{l.Comments}}</td>-->
                                        <td class="padding-top-6px padding-bottom-4px padding-right-0px vertical-align-top">{{RowIndex+1}}</td>
                                        <td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                          <div class="height-16px">
                                            <label class="font-size-14 margin-bottom-0px">{{l.TestName}}</label>
                                          </div>
                                          <div class="row-height-17px">
                                            <label class="font-size-12px margin-bottom-0px">Result : {{l.Result}}{{l.ResultUnits}}</label>
                                          </div>
                                          <div class="row-height-17px">
                                            <label class="font-size-12px margin-bottom-0px">{{l.Comments}}</label>
                                          </div>
                                        </td>
                                        <td class="padding-top-4px padding-bottom-4px">
                                          <!--<a class="nav-link-hand education-navlink margin-right-10px " title="Edit">
                                            <span class="badge font-size-14"><i class="fas fa-pencil-alt"></i></span>
                                          </a>-->
                                          <div class="test-icons float-right">
                                            <a (click)="delTEST(l)" title="Remove" *ngIf="!FollicularPickupEndInfo.IsPickedUp"><i class="fa fa-times color-Rejected delete-test-icon nav-link-hand"></i></a>
                                            <!--<a (click)="EditTest(l)" class="nav-link-hand education-navlink  color-Assign editicon edit-test-icon" title="Edit">
                                              <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                            </a>-->
                                          </div>
                                        </td>




                                      </tr>

                                    </tbody>
                                  </table>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="accordion" id="accordionExamplemedicinenew">
                    <div class="card margin-bottom-5px">
                      <div class="card-header font-weight-normal wh-header border-all-0px border-left-female label-table-color border-top-0px border-right-0 background-primary padding-top-0px padding-right-0px padding-left-5px padding-bottom-0px border-bottom-0px" id="headingmedicinenew">
                        <div class="row">
                          <div class="col-md-4 col-4">
                            <h5 class="mb-0 height-24px">
                              <button class="btn btn-link btn-cycles padding-top-0px padding-bottom-0px padding-right-0px padding-left-0px" type="button" data-toggle="collapse" data-target="#collapsemedicinenew" aria-expanded="true" aria-controls="collapsemedicinenew">
                                Medicines
                              </button>
                            </h5>
                          </div>
                          <div class="col-md-8 col-7 padding-right-0px">
                            <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px margin-left-auto" hidden>Clear</button>
                            <button type="button"
                                    class="btn  btn-sm drive-button3 background-primary border-all-secondary float-right" id="FileUpload" (click)="AddMedicine()"
                                    name="upload" *ngIf="!SelectedpatientDetails.IsReadyForPickup">
                              <i class="fas fa-plus font-size-11"></i>
                            </button>
                          </div>
                        </div>


                      </div>

                      <div id="collapsemedicinenew" class="collapse show" aria-labelledby="headingmedicinenew" data-parent="#accordionExamplemedicinenew">
                        <div class="card-body padding-top-5 padding-bottom-0px margin-left-0px padding-left-5px padding-right-5px">
                          <div class="row">
                            <div class="col-11 padding-right-0px">
                              <div class="table-component">
                                <div class="table-responsive">


                                  <table class="table table-striped margin-left-zero width-50-new">
                                    <!--<thead>
                                                                        <tr>
                                                                          <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 th-width-40px padding-top-4px padding-bottom-4px"></th>
                                                                          <th class="font-weight-normal  background-primary padding-left-4 padding-right-4 padding-top-4px padding-bottom-4px">

                                                                          </th>

                                                                          <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                    </th>
                                    <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                    </th>
                                    <th class="font-weight-normal  background-primary padding-left-4  padding-top-4px padding-bottom-4px">

                                    </th>


                                                                          <th class="font-weight-normal  background-primary padding-top-4px padding-bottom-4px">

                                                                          </th>











                                                                        </tr>
                                                                      </thead>-->
                                    <tbody class="table-body">

                                      <tr *ngFor="let l of CurrentIvfCycleMedicineByCodeController ; let RowIndex = index ">
                                        <td class="padding-top-4px padding-bottom-4px padding-top-6px vertical-align-top">{{RowIndex+1}}</td>
                                        <!--<td class="padding-top-4px padding-bottom-4px padding-left-0px">
                                          <div class="height-16px" >
                                            <label class="font-size-14 margin-bottom-0px">{{l.MedicineName}}</label>
                                          </div>
                                          <div class="height-16px" >
                                            <label class="font-size-12px margin-bottom-0px">{{l.Dose}}</label>
                                          </div>
                                          <div class="height-16px" >
                                            <label class="font-size-12px margin-bottom-0px">{{l.DosageForm}}</label>
                                          </div>
                                          <div class="height-16px" >
                                            <label class="font-size-12px margin-bottom-0px">{{l.Instructions}}</label>
                                          </div>
                                          <div class="height-16px" >
                                            <label class="font-size-12px margin-bottom-0px">{{l.Remarks}}</label>
                                          </div>

                                        </td>-->
                                        <td class="padding-top-4px padding-bottom-4px padding-left-4"><label class="font-size-12px margin-bottom-0px">{{l.MedicineName}}</label></td>
                                        <td class=" padding-top-4px padding-bottom-4px ">{{l.Dose}}</td>
                                        <td class=" padding-top-4px padding-bottom-4px padding-left-4">{{l.DosageForm}}</td>
                                        <td class=" padding-top-4px padding-bottom-4px ">{{l.MedicineInstructions}}</td>

                                        <td class="padding-top-4px padding-bottom-4px ">
                                          <div class="test-icons">
                                            <a class="float-right" (click)="delMedicine(l)" title="Remove" *ngIf="!FollicularPickupEndInfo.IsPickedUp"><i class="fa fa-times color-Rejected nav-link-hand"></i></a>
                                            <!--<a (click)="EditMedicine()" class="nav-link-hand education-navlink  color-Assign" title="Edit">
                                              <span class="badge"><i class="fas fa-pencil-alt"></i></span>
                                            </a>-->
                                          </div>
                                        </td>
                                        <!--<td class="padding-top-4px padding-bottom-4px">


                                        </td>-->




                                      </tr>

                                    </tbody>
                                  </table>

                                </div>
                              </div>
                            </div>
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>




                </div>

              </div>


            </div>
          </div>
        </div>
      </div>

    </div>
  </div>



  <router-outlet></router-outlet>
  <router-outlet name="print"></router-outlet>
</div>
<!--<div class="row" *ngIf="Showivf">
  <div class="col-md-12">
  <ivfworkbench></ivfworkbench>
    </div>
</div>-->
